// extracted by mini-css-extract-plugin
export default {"head2headContainer":"SportUpcoming_head2headContainer__zTdoN","noEvents":"SportUpcoming_noEvents__NfYa-","headToHeadCard":"SportUpcoming_headToHeadCard__v3uXU"};